import { render, staticRenderFns } from "./ClientsNotes.vue?vue&type=template&id=ec4592ba"
import script from "./ClientsNotes.vue?vue&type=script&lang=js"
export * from "./ClientsNotes.vue?vue&type=script&lang=js"
import style0 from "./ClientsNotes.vue?vue&type=style&index=0&id=ec4592ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports